/**
 * Fixed-point integer subpixel math. All sim positions are integers
 * (one tile = SUBPIXELS_PER_TILE subpixels) so replays are byte-identical
 * across machines.
 */

export const SUBPIXELS_PER_TILE = 256;
export const HALF_TILE = SUBPIXELS_PER_TILE >> 1;

/** Tile coordinate (whole tiles) from a fixed-point subpixel value. */
export function toTile(sub: number): number {
  return Math.floor(sub / SUBPIXELS_PER_TILE);
}

/** Fixed-point subpixel position from a whole tile coordinate. */
export function fromTile(tile: number): number {
  return tile * SUBPIXELS_PER_TILE;
}

/** Centered subpixel position from a whole tile coordinate. */
export function tileCenter(tile: number): number {
  return tile * SUBPIXELS_PER_TILE + HALF_TILE;
}

/** Distance from the start of the tile, in subpixels [0, SUBPIXELS_PER_TILE). */
export function offsetInTile(sub: number): number {
  const m = sub % SUBPIXELS_PER_TILE;
  return m < 0 ? m + SUBPIXELS_PER_TILE : m;
}

/** True when the subpixel position is exactly on a tile edge. */
export function onTileBoundary(sub: number): boolean {
  return offsetInTile(sub) === 0;
}
